import React from "react";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";

import FeaturedBlogView from "../../../component/blogList/featuredBlog";
import themeLarge from "../../../component/ThemeLarge";
import { useNavigate } from "react-router-dom";

class LatestBlogMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      featuredBlog: null,
    };
  }

  componentDidMount() {
    this.fetchFeaturedOrLatestBlog();
  }

  fetchFeaturedOrLatestBlog = async () => {
    const db = getFirestore();

    try {
      const featuredDocRef = doc(db, "featured", "current");
      const featuredDocSnap = await getDoc(featuredDocRef);
      const featuredBlogId = featuredDocSnap.exists()
        ? featuredDocSnap.data().blogId
        : null;

      let blogToShow = null;

      if (featuredBlogId) {
        const blogDocRef = doc(db, "blogs", featuredBlogId);
        const blogDocSnap = await getDoc(blogDocRef);
        if (blogDocSnap.exists() && blogDocSnap.data().status === "published") {
          blogToShow = { id: blogDocSnap.id, ...blogDocSnap.data() };
        }
      }

      if (!blogToShow) {
        const q = query(collection(db, "blogs"), where("status", "==", "published"));
        const querySnapshot = await getDocs(q);
        const allBlogs = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (allBlogs.length > 0) {
          allBlogs.sort(
            (a, b) => b.createdAt.toMillis() - a.createdAt.toMillis()
          );
          blogToShow = allBlogs[0];
        }
      }

      this.setState({
        featuredBlog: blogToShow,
      });
    } catch (error) {
      console.error("Error fetching blog:", error);
    }
  };

  handleCardClick = (slug) => {
    const { navigate } = this.props;
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/blogs/${slug}`);
  };

  render() {
    return (
      <div
        className="pt-2 pb-2"
        style={{
          background: themeLarge.colors.secondary,
          paddingLeft: "10px",
          paddingRight: "10px",
          fontFamily: "Kumbh Sans",
        }}
      >
        <div className="container">
          <p
            className="d-flex justify-content-center"
            style={{
              color: themeLarge.colors.text,
              fontSize: themeLarge.fontSize.h3,
              textAlign: "center",
            }}
          >
            Recent Blog
          </p>
          <FeaturedBlogView
            featuredBlog={this.state.featuredBlog}
            onClick={() => this.handleCardClick(this.state.featuredBlog?.slug)}
          />
        </div>
      </div>
    );
  }
}

// Wrap with navigation
function withNavigation(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

export default withNavigation(LatestBlogMobile);
